import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Spinner,
} from "reactstrap";

import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation";
import showNotification from "../../helpers/show_notification";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import exportFromJSON from "export-from-json";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import TagsInput from "react-tagsinput";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../helpers/forms_helper";
import {mapUnits,exportFromula, ExportAvailableInCSVForReports} from "../../helpers/units";
import ReactSelect from "react-select";
// actions

const AllItems = (props) => {
  const { SearchBar } = Search;
  const refContainer = useRef(null);
  const refNewCategoryForm = useRef(null);

  useEffect(() => {
    loadAllCategories();
    loadAllUnits();
    loadAllItems();
    loadAllBrands();
    loadAllLocations();
  }, []);

  const [allLocations, setAllLocations] = useState([]);
  const loadAllLocations = async () => {
    let url = process.env.REACT_APP_BASEURL + "locations/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const formattedData = response.data.map(loc => ({
        value: loc._id,
        label: loc.name
      }));
      setAllLocations(formattedData);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allItems, setAllItems] = useState([]);
  const [allItemsFiltered, setAllItemsFiltered] = useState([]);
  const [isLoadingItems, setIsLoadingItems] = useState(false)
  const patchItemById = (itemId, updater) => {
    setAllItems((prev) => prev.map((item) => (item._id === itemId ? updater(item) : item)));
    setAllItemsFiltered((prev) => prev.map((item) => (item._id === itemId ? updater(item) : item)));
  };
  const loadAllItems = async () => {
   try {
    setIsLoadingItems(true)
    let url = process.env.REACT_APP_BASEURL + "items/getall_for_master";
    let response = await postSubmitForm(url, { list_only: true });
    if (response.status === 1) {
      let data = response.data?.sort((a, b) =>a?.seq_no - b?.seq_no)
      setAllItems(data);
      setAllItemsFiltered(data);
      setSelectedCategoryFilter("");
      setSelectedSubCategoryFilter("");
    } else {
      showNotification(response.message, "Error");
    }
   } catch (error) {
    console.log(error);
   } finally {
    setIsLoadingItems(false)
   }
  };

  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState();
  const loadAllCategories = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemcategories/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllCategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allBrands, setAllBrands] = useState([]);
  const loadAllBrands = async () => {
    let url = process.env.REACT_APP_BASEURL + "brands/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllBrands(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [selectedBrand, setSelectedBrand] = useState();
  const [newBrandModal, setNewBrandModal] = useState();
  const handleAddNewBrand = async (e, v) => {
    const object = {
      name: v.name,
    };
    let url = process.env.REACT_APP_BASEURL + "brands/insert";
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      loadAllBrands();
      setSelectedBrand(v.name);
      setNewBrandModal(!newBrandModal);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allUnits, setAllUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState();
  const [allSubUnits, setAllSubUnits] = useState([]);
  const [selectedSubUnit, setSelectedSubUnit] = useState();
  const loadAllUnits = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemunits/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllUnits(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [newUnitModal, setNewUnitModal] = useState();
  const [newSubUnits, setNewSubUnits] = useState([]);
  const handleAddNewUnit = async (e, v) => {
    const object = {
      unit: v.name,
      sub_unit: newSubUnits,
    };
    let url = process.env.REACT_APP_BASEURL + "itemunits/insert";
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      loadAllUnits();
      setSelectedUnit(v.name);
      setSelectedSubUnit();
      setAllSubUnits(newSubUnits);
      setNewSubUnits([]);
      setNewUnitModal(!newUnitModal);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [newCategoryModal, setNewCategoryModal] = useState();
  const [newSubCategories, setNewSubCategories] = useState([]);
  const handleAddNewCategory = async (e, v) => {
    try {
      const object = {
        category: v.name,
        sub_category: newSubCategories,
      };
      let url = process.env.REACT_APP_BASEURL + "itemcategories/insert";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllCategories();
        setSelectedCategory(v.name);
        setAllSubCategories(newSubCategories);
        setNewSubCategories([]);
        setNewCategoryModal(!newCategoryModal);
        refNewCategoryForm.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }
  };

  const [newSubCategoryModal, setNewSubCategoryModal] = useState();
  const handleAddNewSubCategory = async (e, v) => {
    try {
      const object = {
        category: selectedCategory,
        sub_category: v.name,
      };
      let url =
        process.env.REACT_APP_BASEURL + "itemcategories/insert_subcategory";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllCategories();
        let all_sub_cat = [...allSubCategories];
        all_sub_cat.push(v.name);
        setAllSubCategories(all_sub_cat);
        setSelectedSubCategory(v.name);
        setNewSubCategoryModal(!newSubCategoryModal);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }
  };

  const handleItemStatusUpdate = async (row) => {
   try {
     let url = process.env.REACT_APP_BASEURL + "items/activate_deactivate";
    const nextActive = !row.is_active;
    const response = await postSubmitForm(url, {
      item_id: row._id,
      is_active: nextActive,
    });

    if (response && response.status === 1) {
      patchItemById(row._id, (item) => ({ ...item, is_active: nextActive }));
    } else {
      showNotification(response.message, props.t("Error"));
    }
   } catch (error) {
    console.log(error);
   }
  };
function showStatusFormatter(cell, row) {
  return (
    <>
      <span className="custom-control custom-switch mb-2" dir="ltr">
        <input
          type="checkbox"
          title="Click to change status."
          className="custom-control-input"
          id={"customSwitch1" + row._id}
          checked={row.is_active}
        />
        <label
          title="Click to change status."
          className="custom-control-label"
          htmlFor={"customSwitch1" + row._id}
          style={{ fontWeight: 100, cursor: "pointer" }}
          onClick={() => {
            handleItemStatusUpdate(row);
          }}
        ></label>
      </span>

      {(row.has_stock && !row.is_active) ? (
        <span className="font-size-5 badge-soft-warning badge badge-warning badge-pill">
          {props.t("Has some stock")}
        </span>
      ) : (null
        // <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        //   <span className="font-size-12 badge-soft-danger badge badge-danger badge-pill">
        //     {props.t("Inactive")}
        //   </span>
        //   {row.has_stock && (
        //     <span style={{ fontSize: "12px", fontWeight: 500, color: "#555" }}>
        //       Has Stock
        //     </span>
        //   )} 
        // </div>
      )}
    </>
  );
}


  const [editItemModal, setEditItemModal] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [isPremium, setIsPremium] = useState(false)
  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
      // formatter: (cell, row, rowIndex) => {
      //   const rowNumber = (+pageNumber - 1) * +pageSize + (+rowIndex + 1);
      //   return rowNumber;
      // },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Location"),
      dataField: "location.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "is_premium_item",
      text: props.t("Premium Item"),
      sort: true,
      formatter:(cel,row)=>{
        return row.is_premium_item ? "Yes" :"No"
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "unit_for_po",
      text: props.t("Unit for PO"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Prices"),
      dataField: "unit_for_po",
      sort: true,
      formatter: (cell, row) => {
        return (
          <>
            {/* <div><strong>PO Unit:</strong> {row.unit_for_po}</div> */}
            <div><strong>Old Price:</strong> {row.second_latest_cost_price ?? 0}</div>
            <div><strong>Latest Price:</strong> {row.latest_cost_price ?? 0}</div>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "threshold",
      text: props.t("Centre Threshold"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell, row) => {
        return row.threshold + " " + row.unit_for_threshold
      },
    },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      // formatter: UnitFormatter,
      formatter: (cell,row)=>{
        return mapUnits(row.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Status"),
      dataField: "is_active", 
      formatter: showStatusFormatter,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Action"),
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row) => {
        return (
          <span className="text-info">
            <i
              className="bx bxs-edit font-size-15"
              title="Click to Edit"
              style={{ cursor: "pointer" }}
              onClick={() => {
                let arr = (allCategories || []).filter(
                  (category) => category.category === row.category
                );
                if (arr.length > 0) {
                  setAllSubCategories(arr[0].sub_category);
                }
                if(row.location){
                  setSelectedLocation({label:row.location?.name, value:row.location?._id})
                }
                setSelectedBrand(row.brand);
                setSelectedCategory(row.category);
                setSelectedSubCategory(row.sub_category);
                setEditItemModal(!editItemModal);
                setIsPremium(row.is_premium_item);
                setSelectedItem(row);
              }}
            ></i>
          </span>
        );
      },
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const pagination_options = {
    onPageChange: (page, sizePerPage) => {
      setPageNumber(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 50,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const [selectedLocation, setSelectedLocation] = useState()
  const [isLoading , setIsLoading] = useState(false)
  const handleValidUpdate = async (e, v) => {
    try {
      if(!selectedLocation || !selectedLocation?.value){
        showNotification("Please select location","Warning")
        return
      }
      setIsLoading(true)
      v.id = selectedItem._id;
      v.is_premium_item = isPremium?true:false
      v.location = selectedLocation.value
      let url = process.env.REACT_APP_BASEURL + "Items/update";
      let response = await postSubmitForm(url, v);
      if (response.status === 1) {
        setEditItemModal(!editItemModal);
        setSelectedLocation()
        showNotification(response.message, "Success");
        refContainer.current.reset();
        patchItemById(selectedItem._id, (item) => ({
          ...item,
          name: v.name,
          category: v.category,
          sub_category: v.sub_category,
          brand: v.brand,
          threshold: v.threshold,
          unit_for_threshold: v.unit_for_threshold,
          unit_for_po: v.unit_for_po,
          unit_for_max_order: v.unit_for_max_order,
          is_premium_item: !!isPremium,
          remarks: v.remarks,
          description: v.description,
          location: selectedLocation
            ? { _id: selectedLocation.value, name: selectedLocation.label }
            : item.location,
        }));
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
      setIsLoading(false)
    }
  };

  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState();
  const [allSubCategoriesFilter, setAllSubCategoriesFilter] = useState([]);
  const [selectedSubCategoryFilter, setSelectedSubCategoryFilter] = useState();
  useEffect(() => {
    if (!selectedCategoryFilter) {
      setAllItemsFiltered(allItems);
      return;
    }
    setAllItemsFiltered(
      (allItems || []).filter((item) =>
        item.category === selectedCategoryFilter &&
        (!selectedSubCategoryFilter || item.sub_category === selectedSubCategoryFilter)
      )
    );
  }, [selectedCategoryFilter, selectedSubCategoryFilter, allItems]);

  const handleDownload = async () => {
    const fileName = "all_items";
    const exportType = "xls";

    let data_to_export = allItemsFiltered;

    if (data_to_export) {
      var data = [];
     data_to_export.forEach(function (v) {
        data.push({
          "s.n": v.seq_no,
          name: v.name,
          decription: v.description,
          category: v.category,
          location: v.location?.name,
          sub_category: v.sub_category,
          brand: v.brand,
          unit: v.unit_levels && exportFromula(v.unit_levels),
          remarks: v.remarks,
          premium_item: v.is_premium_item ? "Yes" :"No",
          unit_for_po: v.unit_for_po,
          old_price: v.second_latest_cost_price ?? 0,
          latest_price: v.latest_cost_price ?? 0,
          unit_for_max_order:v.unit_for_max_order,
          threshold: v.threshold + " "+ v.unit_for_threshold,
          available: v.available && v.available.length>0 ? ExportAvailableInCSVForReports(v.available) : " " ,
          is_active: v.is_active ? "Active" : v.has_stock ? " Inactive but has some stock" : "Inactive",
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const defaultSorted = [{
    dataField: 'seq_no',
    order: 'asc'
  }];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Items")}
            breadcrumbItem={props.t("All Items")}
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>

                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <CardTitle>{props.t("All Items")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View/Update all existing items here")}
                  </CardSubtitle>
                  <ToolkitProvider
                    keyField="_id"
                    data={allItemsFiltered && allItemsFiltered}
                    columns={columns}
                    search
                  >
                    {(propst) => (
                      <div>
                        <AvForm>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...propst.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>

                            <Col lg={8} className="text-right">
                              <Row>
                                <Col lg={6}>
                                  <AvField
                                    name="category_filter"
                                    type="select"
                                    value={selectedCategoryFilter}
                                    onChange={(e) => {
                                      setSelectedCategoryFilter(e.target.value);
                                      setSelectedSubCategoryFilter("");
                                      if (e.target.value) {
                                        var categories = JSON.parse(
                                          JSON.stringify(allCategories)
                                        );
                                        let arr = categories.filter(
                                          (category) =>
                                            category.category === e.target.value
                                        );
                                        setAllSubCategoriesFilter(
                                          arr[0].sub_category
                                        );
                                      } else {
                                        setAllSubCategoriesFilter([]);
                                      }
                                    }}
                                  >
                                    <option value="">
                                      {props.t("All Categories")}
                                    </option>
                                    {allCategories &&
                                      allCategories.map((category) => {
                                        return (
                                          <option value={category.category}>
                                            {category.category}
                                          </option>
                                        );
                                      })}
                                  </AvField>
                                </Col>
                                <Col lg={6}>
                                  <AvField
                                    name="sub_category_filter"
                                    type="select"
                                    errorMessage={props.t(
                                      "Category cannot be empty"
                                    )}
                                    onChange={(e) =>
                                      setSelectedSubCategoryFilter(
                                        e.target.value
                                      )
                                    }
                                    value={selectedSubCategoryFilter}
                                  >
                                    <option value="">
                                      {props.t("All Sub-Categories")}
                                    </option>
                                    {allSubCategoriesFilter &&
                                      allSubCategoriesFilter.map(
                                        (sub_category) => {
                                          return (
                                            <option value={sub_category}>
                                              {sub_category}
                                            </option>
                                          );
                                        }
                                      )}
                                  </AvField>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </AvForm>
                        <BootstrapTable
                          {...propst.baseProps}
                          keyField="_id"
                          pagination={paginationFactory(pagination_options)}
                          noDataIndication={isLoadingItems ? <Spinner size={"md"} /> :props.t("No items to display.")}
                          striped
                          defaultSorted={ defaultSorted } 
                          hover
                          condensed
                        />
                      </div>
                    )}
                  </ToolkitProvider>

                  <Modal
                    size="lg"
                    isOpen={editItemModal}
                    toggle={() => {setEditItemModal(!editItemModal);setSelectedLocation()}}
                  >
                    <ModalHeader
                      toggle={() => {setEditItemModal(!editItemModal);setSelectedLocation()}}
                    >
                      {props.t("Update Item")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={handleValidUpdate}
                                ref={refContainer}
                              >
                                <Row>
                                  <Col lg={6}>
                                    <Row>
                                      <Col lg={12}>
                                        <AvField
                                          name="name"
                                          label={props.t("Name")}
                                          value={
                                            selectedItem && selectedItem.name
                                          }
                                          placeholder={props.t(
                                            "Enter Item Name"
                                          )}
                                          type="text"
                                          validate={{
                                            required: { value: true },
                                          }}
                                          errorMessage={props.t(
                                            "Name cannot be empty"
                                          )}
                                        />
                                      </Col>
                                      <Col lg={12}>
                                        <Row>
                                          <Col lg={8}>
                                            <AvField
                                              name="category"
                                              label={props.t("Category")}
                                              type="select"
                                              value={selectedCategory}
                                              validate={{
                                                required: { value: true },
                                              }}
                                              errorMessage={props.t(
                                                "Category cannot be empty"
                                              )}
                                              onChange={(e) => {
                                                setSelectedCategory(
                                                  e.target.value
                                                );
                                                if (e.target.value) {
                                                  var categories = JSON.parse(
                                                    JSON.stringify(
                                                      allCategories
                                                    )
                                                  );

                                                  let arr = categories.filter(
                                                    (category) =>
                                                      category.category ===
                                                      e.target.value
                                                  );
                                                  setAllSubCategories(
                                                    arr[0].sub_category
                                                  );
                                                } else {
                                                  setAllSubCategories([]);
                                                }
                                              }}
                                            >
                                              <option value="">
                                                {props.t("--Select Category--")}
                                              </option>
                                              {allCategories &&
                                                allCategories.map(
                                                  (category) => {
                                                    return (
                                                      <option
                                                        value={
                                                          category.category
                                                        }
                                                      >
                                                        {category.category}
                                                      </option>
                                                    );
                                                  }
                                                )}
                                            </AvField>
                                          </Col>
                                          <Col lg={4}>
                                            <Label>&nbsp;</Label>
                                            <br />
                                            <Link
                                              class="btn btn-success waves-effect waves-light btn-sm"
                                              onClick={() => {
                                                setNewCategoryModal(
                                                  !newCategoryModal
                                                );
                                              }}
                                            >
                                              <i class="mdi mdi-file-plus"></i>{" "}
                                              {props.t("Add New")}
                                            </Link>
                                          </Col>
                                        </Row>
                                      </Col>

                                      <Col lg={12}>
                                        <Row>
                                          <Col lg={8}>
                                            <AvField
                                              name="sub_category"
                                              label={props.t("Sub-Category")}
                                              type="select"
                                              required
                                              errorMessage={props.t(
                                                "Sub-Category cannot be empty"
                                              )}
                                              value={selectedSubCategory}
                                              onChange={(e) => {
                                                setSelectedSubCategory(
                                                  e.target.value
                                                );
                                              }}
                                            >
                                              <option value="">
                                                {props.t(
                                                  "--Select Sub-Category--"
                                                )}
                                              </option>
                                              {allSubCategories &&
                                                allSubCategories.map(
                                                  (subcategory) => {
                                                    return (
                                                      <option
                                                        value={subcategory}
                                                      >
                                                        {subcategory}
                                                      </option>
                                                    );
                                                  }
                                                )}
                                            </AvField>
                                          </Col>
                                          <Col lg={4}>
                                            <Label>&nbsp;</Label>
                                            <br />
                                            <Link
                                              class="btn btn-success waves-effect waves-light btn-sm"
                                              onClick={() => {
                                                if (selectedCategory) {
                                                  setNewSubCategoryModal(
                                                    !newSubCategoryModal
                                                  );
                                                } else {
                                                  showNotification(
                                                    props.t(
                                                      "Select a category first!"
                                                    ),
                                                    props.t("Error")
                                                  );
                                                }
                                              }}
                                            >
                                              <i class="mdi mdi-file-plus"></i>{" "}
                                              {props.t("Add New")}
                                            </Link>
                                          </Col>
                                        </Row>
                                      </Col>
                                      <Col lg={12}>
                                        <AvField
                                          name="threshold"
                                          value={
                                            selectedItem &&
                                            selectedItem.threshold.toString()
                                          }
                                          label={props.t("Centre Threshold")}
                                          placeholder={props.t(
                                            "Enter Threshold Quantity for Centre"
                                          )}
                                          type="text"
                                          validate={{
                                            required: {
                                              value: true,
                                              errorMessage: props.t(
                                                "Threshold cannot be empty."
                                              ),
                                            },
                                            pattern: {
                                              value: "^[0-9]+$",
                                              errorMessage: props.t(
                                                "Only numbers are allowed."
                                              ),
                                            },
                                          }}
                                        />
                                      </Col>

                                      
                          <Col lg={6} className="mt-2">
                                                <AvRadioGroup
                                                inline
                                                name="is_premium_item"
                                                required
                                                value={isPremium? "Yes": "No"
                                                }
                                                validate={{required: { value: true },}}
                                                errorMessage={props.t("Select an option")}
                                                >
                                                <Label>{props.t("Premium Item ?")}</Label>
                                                <br />
                                                <AvRadio
                                                    onChange={(e, v) => {
                                                    setIsPremium(true);
                                                    }}
                                                    label="Yes"
                                                    value="Yes"
                                                />
                                                <AvRadio
                                                    onChange={(e, v) => {
                                                    setIsPremium(false);
                                                    }}
                                                    label="No"
                                                    value="No"
                                                />
                                                </AvRadioGroup>
                            </Col>

                                    </Row>
                                  </Col>{" "}
                                  <Col lg={6}>
                                    <Row>
                                      <Col lg={12}>
                                        <Row>
                                          <Col lg={8}>
                                            <AvField
                                              name="brand"
                                              label={props.t("Brand")}
                                              type="select"
                                              validate={{
                                                required: { value: true },
                                              }}
                                              errorMessage={props.t(
                                                "Brand cannot be empty"
                                              )}
                                              value={selectedBrand}
                                              onChange={(e) => {
                                                setSelectedBrand(
                                                  e.target.value
                                                );
                                              }}
                                            >
                                              {" "}
                                              <option value="">
                                                {props.t("--Select Brand--")}
                                              </option>
                                              {allBrands &&
                                                allBrands.map((brand) => {
                                                  return (
                                                    <option value={brand.name}>
                                                      {brand.name}
                                                    </option>
                                                  );
                                                })}
                                            </AvField>
                                          </Col>
                                          <Col lg={4}>
                                            <Label>&nbsp;</Label>
                                            <br />
                                            <Link
                                              class="btn btn-success waves-effect waves-light btn-sm"
                                              onClick={() => {
                                                setNewBrandModal(
                                                  !newBrandModal
                                                );
                                              }}
                                            >
                                              <i class="mdi mdi-file-plus"></i>{" "}
                                              {props.t("Add New")}
                                            </Link>
                                          </Col>
                                        </Row>
                                      </Col>

                                     
                                       <Col lg={6}>
                                <AvField
                                  name="unit_for_max_order"
                                  label={props.t("Ordering Unit/Max Order Unit")}
                                  type="select"
                                  value={selectedItem?.unit_for_max_order}
                                  validate={{ required: { value: true } }}
                                  errorMessage={props.t(
                                    "Ordering Unit/Max Order Unit is required "
                                  )}
                                  
                                >
                               
                                  <option value="">
                                    {props.t("--Select Unit--")}
                                  </option>
                                  {selectedItem?.unit_levels.map((item) => {
                                      return (
                                        <option value={item.unit}>
                                          {item.unit}
                                        </option>
                                      )
                                    })}
                                  
                                </AvField>
                              </Col>

                              <Col lg={6}>
                                <AvField
                                  name="unit_for_po"
                                  label={props.t("Unit for PO")}
                                  type="select"
                                  value={selectedItem?.unit_for_po}
                                  validate={{ required: { value: true } }}
                                  errorMessage={props.t(
                                    "Unit for PO required "
                                  )}
                                  
                                >
                               
                                  <option value="">
                                    {props.t("--Select Unit--")}
                                  </option>
                                  {selectedItem?.unit_levels.map((item) => {
                                      return (
                                        <option value={item.unit}>
                                          {item.unit}
                                        </option>
                                      )
                                    })}
                                  
                                </AvField>
                              </Col>

                              <Col lg={6}>
                                <AvField
                                  name="unit_for_threshold"
                                  label={props.t("Unit for Cr.Thrsld")}
                                  type="select"
                                  value={selectedItem?.unit_for_threshold}
                                  validate={{ required: { value: true } }}
                                  errorMessage={props.t(
                                    "Unit for threshold required "
                                  )}
                                  
                                >
                               
                                  <option value="">
                                    {props.t("--Select Unit--")}
                                  </option>
                                  {selectedItem?.unit_levels.map((item) => {
                                      return (
                                        <option value={item.unit}>
                                          {item.unit}
                                        </option>
                                      )
                                    })}
                                  
                                </AvField>
                              </Col>
                              <Col lg={6} md={6}>
                        <Label>{props.t("Location")}</Label>
                        <ReactSelect
                          name="location"
                          options={allLocations}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={selectedLocation}
                          onChange={setSelectedLocation}
                          placeholder={props.t("Select Location...")}
                        />
                      </Col>
                                      
                                      <Col lg={12}>
                                        <AvField
                                          name="description"
                                          label={props.t("Description")}
                                          value={
                                            selectedItem &&
                                            selectedItem.description
                                          }
                                          placeholder={props.t(
                                            "Enter Description"
                                          )}
                                          type="text"
                                        />
                                      </Col>
                                      <Col lg={12}>
                                        <AvField
                                          name="remarks"
                                          label={props.t("Remarks")}
                                          placeholder={props.t("Enter Remarks")}
                                          type="textarea"
                                          value={
                                            selectedItem && selectedItem.remarks
                                          }
                                        />
                                      </Col>
                                     
                                    </Row>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                    <div>
                        <Button type="submit" color="primary" className="mr-1" disabled={isLoading} style={{width:"100px"}}>
                          { isLoading ? <Spinner size={"sm"}/> :props.t("Update")}
                        </Button>
                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                {/* <Button type="submit">Submit</Button> */}
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

                  {/* add new brand modal start  */}
                  <Modal
                    size="md"
                    isOpen={newBrandModal}
                    toggle={() => setNewBrandModal(!newBrandModal)}
                  >
                    <ModalHeader
                      toggle={() => setNewBrandModal(!newBrandModal)}
                    >
                      {props.t("Add new brand")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewBrand(e, v);
                                }}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Name of Brand") + " *"}
                                      placeholder={props.t("Enter Brand Name")}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty."
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>

                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

                  {/* add new brand modal end  */}

                  <Modal
                    size="md"
                    isOpen={newUnitModal}
                    toggle={() => setNewUnitModal(!newUnitModal)}
                  >
                    <ModalHeader toggle={() => setNewUnitModal(!newUnitModal)}>
                      {props.t("Add new unit")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewUnit(e, v);
                                }}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Name of Unit") + " *"}
                                      placeholder={props.t("Enter Unit Name")}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty."
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <Label>{props.t("Sub-Unit")}</Label> (
                                    {props.t("press ENTER/TAB to add")})
                                    <TagsInput
                                      value={newSubUnits}
                                      onChange={(tags) => {
                                        setNewSubUnits(tags);
                                      }}
                                      onlyUnique={true}
                                      inputProps={{
                                        className: "react-tagsinput-input",
                                        placeholder: props.t("Add..."),
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>
                  

                  {/* Category Modal Start */}
                  <Modal
                    size="md"
                    isOpen={newCategoryModal}
                    toggle={() => setNewCategoryModal(!newCategoryModal)}
                  >
                    <ModalHeader
                      toggle={() => setNewCategoryModal(!newCategoryModal)}
                    >
                      {props.t("Add new category")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewCategory(e, v);
                                }}
                                ref={refNewCategoryForm}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Category")}
                                      placeholder={props.t(
                                        "Enter Category Name"
                                      )}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty"
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <Label>
                                      {props.t("Sub-Category Name")}
                                    </Label>{" "}
                                    ({props.t("press ENTER/TAB to add")})
                                    <TagsInput
                                      value={newSubCategories}
                                      onChange={(tags) => {
                                        setNewSubCategories(tags);
                                      }}
                                      onlyUnique={true}
                                      inputProps={{
                                        className: "react-tagsinput-input",
                                        placeholder: props.t("Add..."),
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>
                  {/* category modal end  */}

                  {/* sub category modal start  */}
                  <Modal
                    size="md"
                    isOpen={newSubCategoryModal}
                    toggle={() => setNewSubCategoryModal(!newSubCategoryModal)}
                  >
                    <ModalHeader
                      toggle={() =>
                        setNewSubCategoryModal(!newSubCategoryModal)
                      }
                    >
                      {props.t("Add new sub-category")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleAddNewSubCategory(e, v);
                                }}
                                ref={refNewCategoryForm}
                              >
                                <Row>
                                  <Col lg={12}>
                                    <AvField
                                      name="name"
                                      label={props.t("Sub-Category")}
                                      placeholder={props.t(
                                        "Enter Sub-Category Name"
                                      )}
                                      type="text"
                                      validate={{
                                        required: {
                                          value: true,
                                          errorMessage: props.t(
                                            "Name cannot be empty"
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>

                                  <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>
                  {/* sub category modal end  */}


                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(AllItems)));
